import { bind } from '../../../../../shared/helpers/decorators';
import { RoomAgentError } from '../errors/RoomAgentError';

export interface Resolution {
    width: number;
    height: number;
}

interface ConstructorParams {
    resolution: Resolution;
    h264ProfileLevelId?: string;
    content?: string;
}

export class RecorderVideo {
    private canvas: HTMLCanvasElement;
    private _ctx: Maybe<CanvasRenderingContext2D>;
    private stream: MediaStream;
    private track: MediaStreamTrack;

    public resolution: Resolution;
    public h264ProfileLevelId?: string;
    public content?: string;

    constructor({ resolution, h264ProfileLevelId, content }: ConstructorParams) {
        this.resolution = resolution;
        this.content = content;
        this.h264ProfileLevelId = h264ProfileLevelId;

        this.canvas = document.createElement('canvas');
        this.canvas.style.position = 'fixed';
        this.canvas.style.top = '10px';
        this.canvas.style.left = '10px';
        this.canvas.style.visibility = 'hidden';
        this.canvas.style.transform = 'scale(0.3)';
        this.canvas.style.transformOrigin = 'top left';
        this.canvas.style.display = 'none';
        this.canvas.width = resolution.width;
        this.canvas.height = resolution.height;

        document.body.appendChild(this.canvas);

        this.stream = this.canvas.captureStream();
        this.track = this.stream.getVideoTracks()[0];

        if (!this.track) {
            throw new RoomAgentError('RecorderVideo has no video track.', undefined, { method: 'RecorderVideo' });
        }
    }

    public get ctx() {
        if (!this._ctx) {
            const ctx = this.canvas.getContext('2d');

            if (!ctx) {
                throw new Error('No 2d context');
            }

            this._ctx = ctx;
        }

        return this._ctx;
    }

    @bind
    public destroy() {
        this._ctx = undefined;

        document.body.removeChild(this.canvas);
    }

    @bind
    public getTrack() {
        return this.track;
    }

    @bind
    public applyConstraints(constraints: MediaTrackConstraints) {
        this.track.applyConstraints(constraints).catch((error) => {
            throw new RoomAgentError('RecorderVideo error', error?.message || 'applyConstraints error', {
                method: 'applyConstraints',
            });
        });
    }
}
